import Request from 'utils/request';
import config from 'config/Config';
import Stores from 'config/Stores';
import Util from 'utils';
import AppMod from 'widget/App/AppMod';
import { toJS } from 'mobx';

const request = () => {
  const url = document.location.href.split('#')[0];
  return Request({
    url: `user/login/getWechatMpSignature`,
    host: config.HOST_MALL,
    params: {
      url,
      state: Util.getQueryString('state') || 'WechatBaseLogin' // 微信返回带state
    },
    ignoreErr: true
  });
};

// 初始化微信jssdk配置
const initConfig = () => {
  request().then(({ data, resultCode, resultMsg }) => {
    wx.config({
      debug: false,
      appId: data.appId,
      timestamp: data.timestamp,
      nonceStr: data.nonceStr,
      signature: data.signature,
      jsApiList: [
        'updateAppMessageShareData',
        'updateTimelineShareData',
        'onMenuShareTimeline',
        'previewImage',
        'hideMenuItems',
        'chooseImage',
        'uploadImage',
        'onMenuShareAppMessage',
        'onMenuShareQQ',
        'onMenuShareWeibo',
        'getLocation',
        'openLocation',
        'getNetworkType',
        'scanQRCode',
        'wx-open-subscribe',
        'wx-open-launch-app'
      ],
      openTagList: ['wx-open-launch-weapp']
    });
    wx.error(function (res) {
      console.log('wxerror', res);
    });
  });
};

// 动态获取企微appId(企微会出现多个主体同时使用h5)
const getWorkWechatAppId = async () => {
  const workWechatAppIdMap = await Request({
    url: `https://image.yofogo.com/config/appId.json`,
    host: config.HOST_JSON,
    method: 'get',
    withCredentials: false,
    ignoreErr: true
  });
  const agentId = Stores.AppMod.workWechatAgentId;
  const appId = workWechatAppIdMap[agentId] || config.wwAppId;
  return appId;
};
/**
 * 微信登录
 * @param {*} param0
 * type 静默登录 绑定登录
 * @returns
 */
const wechatLogin = ({ scope = '', redirectPath = '', inletTitle = '', type = '' } = {}) => {
  const member_appId = Util.getQueryString('appid') || Util.getQueryString('appId');
  if (Util.isWeiXin() && !AppMod.isInternationalized) {
    if (Stores.AppMod.workWechatAgentId) {
      getWorkWechatAppId().then((appId) => {
        // 通过其他域名授权的appId，目前只有优优电子;
        const otherEmpowerAppIdList = {
          ww15f70b3d2fce00f2: 'http://work.yydzkeji.cn',
          ww3d9401603403eef9: 'http://work.fniaobl.cn'
        };

        const host = config.HOST && config.HOST.toLowerCase();
        const route = window.location.href.split('#') || [];
        const routeParam = (route[1] && route[1].split('?')) || [];
        if (otherEmpowerAppIdList[appId]) {
          const replaceUrl = `${otherEmpowerAppIdList[appId] || 'http://work.yydzkeji.cn'}/workWechatAuth.html?agentId=${Stores.AppMod.workWechatAgentId}&redirectPath=${redirectPath || routeParam[0] || ''}&host=${host}&redirectParam=${routeParam[1] || ''}`;
          window.location.replace(replaceUrl);
        } else {
          sessionStorage.removeItem('routerCount');
          window.location.replace(
            `#/WechatBackLoginAuth${scope ? `?scope=${scope}&type=${type}` : `?type=${type}`}`
          );
        }
      });
      return;
    } else if (Util.getLocalCache('member_appId') == '10716881' || member_appId == '10716881') {
      Util.setLocalCache('member_appId', member_appId || ''); // 防止异常未存储到应用APPID
      // HLW
      // window.app.routerGoTo({ pathname: '/login', state: { inletTitle } });

      Util.setLocalCache('loginH5Goback', window.location.href);
      Util.checkHWLJump();

      return;
    }
    window.location.replace(
      `#/WechatBackLoginAuth${scope ? `?scope=${scope}&type=${type}` : `?type=${type}`}`
    );
  } else {
    window.app.routerGoTo({ pathname: '/login', state: { inletTitle } });
  }
};

// 是否微信小程序环境
const isWeChatMiniProgram =
  navigator.userAgent && navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1;

export { initConfig, wechatLogin, getWorkWechatAppId, isWeChatMiniProgram };



// WEBPACK FOOTER //
// ./src/utils/wxUtils.js